module.exports = __webpack_public_path__ + "e8dede617f0ba4c91cdb7dfc306ba068.svg";